import React from 'react'
import { connect } from 'react-redux'
import Slider from 'react-animated-slider';
import { NavLink } from 'react-router-dom'
import 'react-animated-slider/build/horizontal.css';
import './slider-animations.css';
import { get, post } from '../../../utils/networking'
import { configs } from '../../../helpers/constants'
import './style.css'
import $ from 'jquery'
class TopSlider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: [],
            windowWidth: 0
        }
    }

    componentDidMount() {
        post("blog/get", { "skip": 0, "take": 5 }, "", result => {
            if (result) {
                let content = this.state.content;

                result.items.map((item) => {
                    let slide_item = {
                        title: item.title,
                        description: item.synopsis,
                        button: 'Read more',
                        image: configs.api_domain + item.photo,
                        url: "/blog/" + item.slug
                    }
                    content.push(slide_item);
                })
                this.setState({
                    content,
                    windowWidth: $(window).width()
                })

            }
        })
    }

    render() {
        let {
            content,
            windowWidth
        } = this.state;
        return (
            <div className="top_slider">
                {content.length > 1 && <Slider className="slider-wrapper"
                    autoplay={1000}
                    infinite={true}
                    touchDisabled={true}
                >
                    {content.map((item, index) => (
                        <div
                            key={index}
                            className="slider-content"
                            style={{ background: `url('${item.image}') no-repeat center center` }}
                        >
                            <div className="inner">
                                <h4>{(windowWidth > 767) ? item.title : ((item.title.length > 40) ? (item.title.substr(0, item.title.substr(0, 40).lastIndexOf(" ")) + "...") : item.title)}</h4>
                                <p>{(windowWidth > 767) ? item.description : ((item.description.length > 110) ? (item.description.substr(0, item.description.substr(0, 110).lastIndexOf(" ")) + "...") : item.description)}</p>
                                <NavLink to={item.url}><button>{item.button}</button></NavLink>
                            </div>
                        </div>
                    ))}
                </Slider>}
            </div>
        )
    }
}
export default connect(
    state => ({
    }),
    dispatch => ({
    })
)(TopSlider)


// WEBPACK FOOTER //
// ./src/components/home/slider/index.js